<template>
  <div class="business-equipmentlist">
    <h2 class="top-title">设备管理</h2>
    <!-- <Card dis-hover> -->
    <ul class="common-search li-margin">
      <li>
        <span>设备名称: </span>
        <Input
          v-model="dataForm.name"
          name="eqname"
          @on-search="(e) => searchInput(e, 'name')"
          search
          placeholder="请输入"
        />
      </li>
      <li>
        <span>设备编号: </span>
        <Input
          v-model="dataForm.deviceCode"
          @on-search="(e) => searchInput(e, 'deviceCode')"
          search
          placeholder="请输入"
        />
      </li>
      <li>
        <span>设备类型: </span>
        <Select
          v-model="dataForm.deviceTypeId"
          @on-change="(e) => changeSel(e, 'deviceTypeId')"
          :clearable="true"
          placeholder="全部"
        >
          <OptionGroup
            :label="cus.value"
            :key="cus.id"
            v-for="cus in dataCenter.deviceType"
          >
            <Option
              :key="cus2.id"
              :value="cus2.id"
              v-for="cus2 in cus.children"
              >{{ cus2.value }}</Option
            >
          </OptionGroup>
        </Select>
      </li>

      <li v-if="userRole.indexOf('c') == -1">
        <span>客户名称: </span>
        <Input
          v-model="dataForm.consumerName"
          @on-search="(e) => searchInput(e, 'consumerName')"
          search
          placeholder="请输入"
        />
      </li>
      <li v-if="userRole.indexOf('m1') > -1 || userRole.indexOf('c1') > -1">
        <span>所在设备组: </span>
        <Select
          v-model="dataForm.workshopId"
          @on-change="(e) => changeSel(e, 'workshopId')"
          :clearable="true"
          placeholder="全部"
        >
          <Option
            :key="brand.id"
            :value="brand.id"
            v-for="brand in dataCenter.workShop"
            >{{ brand.value }}</Option
          >
        </Select>
      </li>
      <li class="dataPicker">
        <span>创建时间: </span>
        <DatePicker
          :clearable="false"
          @on-change="changeDate"
          v-model="dataForm.date"
          type="daterange"
          format="yyyy-MM-dd"
          placeholder="请选择"
        />
      </li>
      <li class="searchItem">
        <Button class="sels-item" @click="resetData">重置</Button>
      </li>
    </ul>

    <!-- selected -->
    <div class="common-selects selected-margin" v-if="selItems.length">
      <span class="tit">已选:</span>
      <span class="sel" v-for="(item, index) in selItems" :key="index"
        >{{ item.val }}
        <Icon @click="delSelItem(item, index)" type="md-close-circle" />
      </span>
    </div>

    <!-- v-if='dataLists.length' -->
    <div class="lists clearfix list-margin">
      <template     >
      <Button
      v-nohasPermi="['m3','m4']"
        type="primary"
        id="equadd"
        @click="addEquipment()"
        v-if="userRole.indexOf('m') > -1 || userRole.includes('c1')"
      >
        <Icon type="md-add" /> 新增设备
      </Button>
      </template>
      <!-- 列表 -->
      <div class="common-list table-margin">
        <Table
          class="equipmentTable"
          :columns="dataColumn"
          :data="dataLists"
        ></Table>
      </div>
      <!-- <div class="common-nodatas">
                    <img src="@/assets/images/nodatas.png" alt="">
                    <div class="desc">
                        <h4 class="tit">无内容</h4>
                        <p class="msg">当前列表没有数据</p>
                    </div>
                </div> -->
      <!-- 分页器 -->
      <div class="common-page fr" id="equPage" v-if="pageInfo.total">
        <Page
          show-total
          show-elevator
          show-sizer
          :total="pageInfo.total"
          :current="pageInfo.current"
          :page-size="pageInfo.size"
          @on-change="getLists"
          @on-page-size-change="getListsSize"
        >
        </Page>
      </div>
    </div>

    <!-- </Card> -->

    <EquipmentlistDrawer
      ref="equipmentlistDrawer"
      :showDrawer="showDrawer"
      :closeDrawer="closeDrawer"
      :dataCenter="dataCenter"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
      :timernum="timernum"
    ></EquipmentlistDrawer>

    <Modal
      class="newModal"
      v-model="editPop"
      title="编辑设备"
      width="480px"
      @on-ok="editCode"
      @on-cancel="editPop = false"
    >
      <!-- <div class="item" style="padding:20px 0">
                设备编号<Input v-model="editCodeForm.consumerCode"></Input>
            </div> -->
      <Form
        ref="formValidate"
        :model="editCodeForm"
        :rules="ruleCustom"
        label-position="top"
      >
        <FormItem label="设备编号" prop="consumerCode">
          <Input v-model="editCodeForm.consumerCode" placeholder="请输入" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import { mapState } from "vuex";
import handleSelItem from "@/mixins/handleSelItem";
import EquipmentlistDrawer from "./components/equipmentlist-drawer.vue";
import sizeData from "@/mixins/sizeData";
import { oilSiteGetList, relatedInfo, sockedDel } from "@/api/business/rhlist";

export default {
  name: "business-equipmentlist",
  mixins: [handleSelItem, sizeData],
  components: {
    EquipmentlistDrawer,
  },
  computed: {
    ...mapState({
      dataCenter: (state) => state.dataCenter,
      sockedlist: (state) => state.pub.sockedlist,
    }),
  },
  data() {
    const validatePass = (rule, value, callback) => {
      // const valueCopy = value.replace(/\s/g, "");
      if (/[^\w\.\/]/gi.test(value)) {
        callback(new Error("请填写数字或者字母"));
      } else {
        callback();
      }
    };
    return {
      soikobj: "",
      timernum: "",
      userRole: ls.get("userRole"),
      dataLists: [],
      selItems: [],
      dataForm: {},
      editCodeForm: {},
      pageInfo: {
        size: 10,
        current: 1,
        total: 0,
      },
      showDrawer: false,
      editPop: false,
      curItemDetail: {},
      ruleCustom: {
        consumerCode: [
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
      dataColumn: [
        {
          title: "序号",
          type: "index",
          width: 80,

          fixed: "left",
        },
        {
          title: "设备名称",
          key: "name",
          width: 200,
          fixed: "left",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.name || "-");
          },
        },
        {
          title: "设备编号",
          key: "consumerCode",
          width: 220,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.globalCode || "-");
          },
        },
        {
          title: "设备类型",
          key: "deviceTypeName",
          width: 220,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.deviceTypeName || "-");
          },
        },
        {
          title: "设备制造商",
          key: "manufacturer",
          width: 150,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.manufacturer || "-");
          },
        },
        {
          title: "规格型号",
          key: "specifications",
          width: 150,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.specifications || "-");
          },
        },
        {
          title: "所属客户",
          key: "consumerName",
          width: 220,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.consumerName || "-");
          },
        },
        {
          title: "客户行业",
          key: "customerIndustryName",
          width: 150,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.customerIndustryName || "-");
          },
        },
        {
          title: "所在设备组",
          key: "workshopName",
          width: 150,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.workshopName || "-");
          },
        },
        {
          title: "润滑点数量",
          key: "oilSiteCount",
          width: 120,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.oilSiteCount || "-");
          },
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          width: 180,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.gmtCreate || "-");
          },
        },
        {
          title: "操作",
          key: "address",
          align: "left",
          fixed: "right",
          width: 130,
          className: "action",
          render: (h, params) => {
            let userRole = this.userRole;
            const showIt = userRole.indexOf("m1") > -1;
            const item = params.row;
            let btns = [];
            if (
              userRole == "m1" ||
              item.groupAuthorityString == "rw" ||
              userRole == "c1"
            ) {
              btns = [
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.editDetail(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#ed4014"
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.delItemWarning(params.row);
                      },
                    },
                  },
                  "删除"
                ),
              ];
            } 
         

            return h(
              "div",
             
              {
                 attrs:{
                  id:"menus"+params.index
                },
                class: "equimenus",
              },
              btns
            );
          },
        },
      ],
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.getLists();
    this.$store.dispatch("listCollection", "deviceType"); // 设备类型
    this.$store.dispatch("listCollection", "workShop"); // 设备组
    if (!['c0', 'c1'].includes(this.userRole)) {
      this.$store.dispatch("listCollection", "consumer"); // 客户
    }
  },
  methods: {
    init() {
      // 非美孚角色-删除客户名称展示
      let cazoitem = this.$c.deepClone(this.dataColumn)[
        this.dataColumn.length - 1
      ];

      if (this.userRole.indexOf("m") < 0) {
        //m
        // this.dataColumn.forEach((res, index) => {
        //     if (res.title === "所属客户") this.dataColumn.splice(index, 1);
        // });
        this.dataColumn.forEach((res, index) => {
          if (res.title === "客户行业") this.dataColumn.splice(index, 1);
          if (res.title == "所属客户") {
            let obj = this.dataColumn[index];
            obj.width = 370;
            this.$set(this.dataColumn, index, obj);
          }
        });
        this.dataColumn.forEach((res, index) => {
          if (res.title === "设备制造商") this.dataColumn.splice(index, 1);
          if (res.title == "规格型号") {
            let obj4 = this.dataColumn[index];
            obj4.width = 370;
            this.$set(this.dataColumn, index, obj4);
          }
        });
      }

      if (
        this.userRole.indexOf("m1") < 0 && //美孚管理员
        this.userRole.indexOf("c1") < 0 //客户管理员
      ) {
        this.dataColumn.forEach((res, index) => {
          if (res.title === "操作") this.dataColumn.splice(index, 1);
          if (res.title == "创建时间") {
            let obj1 = this.dataColumn[index];
            obj1.width = 300;
            this.$set(this.dataColumn, index, obj1);
          }
        });
        this.dataColumn.forEach((res, index) => {
          // if (res.title === "所在设备组") this.dataColumn.splice(index, 1);
          if (res.title == "设备名称") {
            let obj2 = this.dataColumn[index];
            obj2.width = 350;
            this.$set(this.dataColumn, index, obj2);
          }
        });
      }
      if (this.userRole.indexOf("c") >= 0) {
        let findIndex = this.dataColumn.findIndex((e) => e.title == "所属客户");
        this.dataColumn.splice(findIndex, 1);
        let findIndex2 = this.dataColumn.findIndex(
          (e) => e.title == "创建时间"
        );
        let obj4 = this.dataColumn[findIndex2];
        obj4.width = 400;
        this.$set(this.dataColumn, findIndex2, obj4);
      }
      if (this.userRole == "m0") {
        this.dataColumn.push(cazoitem);
      }

      //  let timernum
      let item = this.sockedlist.find((e) => e.type == "device");
      this.soikobj = item;
      this.timernum = item.totalTime * (1000 * 60);
    },
    getLists(page) {
      this.$store.state.spinShow = true;
      if (page) this.pageInfo.current = page; //分页处理
      api
        .axss("post", "/ocm-oil-site/device/page", {
          ...this.pageInfo,
          ...this.dataForm,
        })
        .then((res) => {
          if (res.code === "00000") {
            const datas = res.data;
            this.dataLists = datas.records;
            this.pageInfo.total = datas.total;
            this.$store.state.spinShow = false;
          }
        })
        .catch((res) => {
          this.$store.state.spinShow = false;
        });
    },
    getListsSize(size) {
      this.pageInfo.size = size;
      this.getLists(1);
    },
    searchInput(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeSel(val, name) {
      this.selItems = this.handleSelItem(val, name, this.dataCenter);
      this.getLists(1);
    },
    changeDate(date, name) {
      this.dataForm.gmtCreateDateStart = date[0];
      this.dataForm.gmtCreateDateEnd = date[1];
      this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      this.getLists(1);
    },
    delSelItem(selItem, index) {
      this.dataForm[selItem.name] = null;

      //日期需要单独处理
      if (selItem.name === "date") {
        delete this.dataForm.gmtCreateDateStart;
        delete this.dataForm.gmtCreateDateEnd;
      }

      this.selItems.splice(index, 1);
      this.getLists(1);
    },
    addEquipment() {
      this.curItemDetail = {}; // 重置form
      this.showDrawer = true;
    },
    async editDetail(item) {
      let data = await relatedInfo({
        id: item.id,
        type: this.soikobj.type,
        chinaType: this.soikobj.typeName,
      });

      if (data.data) {
        this.curItemDetail = deepcopy(item);
       
        this.showDrawer = true;
      } else {
        this.$Message.info(data.msg);
      }
    },
    editDetailPop(item) {
      this.curItemDetail = deepcopy(item);
      this.editCodeForm.id = item.id;
      this.editCodeForm.consumerCode = item.consumerCode;
      this.editPop = true;
    },
    editCode() {
      api
        .axss("post", "/ocm-oil-site/device/consumer/edit", this.editCodeForm)
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("编辑成功");
            this.editPop = false;
            this.getLists(); // 刷新列表
          }
        });
    },
    delItemWarning(item) {
      this.curItemDetail = deepcopy(item);
      this.$Modal.confirm({
        title: "您确定要删除该设备吗？",
        content: `设备名称：${item.name}`,
        onOk: () => {
          this.delItem();
        },
        onCancel: () => {},
      });
    },
    delItem() {
      api
        .axss("post", `/ocm-oil-site/device/del`, [this.curItemDetail.id])
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("删除成功");
            this.curItemDetail = {};
            const finalSize = this.sizeData(
              this.pageInfo.size,
              this.pageInfo.current,
              this.pageInfo.total
            );
            this.getLists(finalSize);
          }
        });
    },
    async closeDrawer() {
      this.showDrawer = false;
      this.$nextTick(async () => {
        if (this.curItemDetail.id) {
          let { data } = await sockedDel({
            id: this.curItemDetail.id,
            type: this.soikobj.type,
          });
        }

        this.curItemDetail = {};
      });
    },
    resetData() {
      this.reset("dataForm");
      this.getLists(1);
    },
    reset(key) {
      this.selItems = [];
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
  },
};
</script>

<style lang='less' scoped>
.business-equipmentlist {
  .lists {
    margin-top: 20px;
  }
}
</style>